var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExamViewsIconM = function SvgExamViewsIconM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M3.81 5.76h.2a2.8 2.8 0 1 0 5.58 0h.2-.2a2.801 2.801 0 0 0-5.58 0h-.2Zm1.307 0H4.01h1.107a1.7 1.7 0 1 0 3.366 0H9.59 8.483a1.7 1.7 0 0 0-3.366 0Zm.203 0h-.203.203Zm2.96 0h.203-.203Zm4.128 0h.212C11.726 3.161 9.465 1.3 6.8 1.3 4.135 1.3 1.874 3.162.98 5.76a.74.74 0 0 0 0 .48c.894 2.598 3.155 4.46 5.82 4.46 2.665 0 4.926-1.862 5.82-4.46a.742.742 0 0 0 0-.48h-.212Zm-12.3-.41C1.148 2.327 3.76.2 6.8.2c3.04 0 5.651 2.126 6.692 5.15a2.01 2.01 0 0 1 0 1.3C12.452 9.673 9.84 11.8 6.8 11.8c-3.04 0-5.651-2.126-6.692-5.15a2.009 2.009 0 0 1 0-1.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgExamViewsIconM;